import React from 'react';
import styled from 'styled-components';

import { STATIC_ROOT } from '../../constants';

import './GoogleMaps.scss';

const MarkerWrapper = styled.button`
    z-index: ${props => props.zIndex};
    position: absolute;
    bottom: 0;
    left: 0;
    height: 44px;
    width: 34px;
    transform: translate(-50%, 0);
    background: url(${STATIC_ROOT}/maps/pin.svg) 0 0 no-repeat;
    text-align: center;
    outline: none;
    border: none;
    cursor: pointer;

    span {
        position: relative;
        top: -4px;
        color: #fff;
        font-weight: bold;
        font-size: 14px;
    }
`;

class ShopMarker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDetails: false,
            active: false
        };
    }

    toggleDetails = () => {
        this.setState({
            showDetails: !this.state.showDetails
        });
    };

    render() {
        const {
            zindex,
            index,
            discount,
            address,
            name,
            logo,
            userPosition,
            distance,
            onHover,
            onActivate
        } = this.props;

        const { fixed, percent } = discount ? discount : 0;
        const value = (fixed || percent) && (
            <React.Fragment>
                {fixed ? `${fixed}€` : ''}
                {fixed && percent ? ' + ' : ''}
                {percent ? `${percent}%` : ''}
            </React.Fragment>
        );

        return (
            <React.Fragment>
                <MarkerWrapper
                    zIndex={-zindex}
                    onClick={() => {
                        onActivate(this.state.active);
                    }}
                    onMouseOver={() => onHover(true)}
                    onMouseOut={() => onHover(false)}>
                    <span>{index}</span>
                </MarkerWrapper>

                {this.state.active && (
                    <div
                        className="markerDetails"
                        onMouseOver={() => onHover(true)}
                        onMouseOut={() => onHover(false)}>
                        {!!value && <div className="mapDiscount">Jusqu'à {value} de Cashback</div>}

                        <div className="content">
                            <img src={logo} alt="logo" />
                            <div>
                                <b>{name}</b>
                                <span>{address.labels.join(' ')}</span>
                                <span>
                                    {address.postcode} {address.city}
                                    {userPosition && distance && (
                                        <span>
                                            &nbsp;- <em>{distance}km</em>
                                        </span>
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="arrow" />
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default ShopMarker;



// WEBPACK FOOTER //
// ./src/components/googlemaps/ShopMarker.js